import React, { useState } from 'react';
import { GuestPortalTopnav } from "../../Topnav";
import { AnnouncementBanner } from '../../AnnouncementBanner';
import { Tabs } from '@shared/ui/tabs';
import { Building2, HelpCircle, Lightbulb } from 'lucide-react';
import FAQSection from './faqs/FAQSection';
import FAQSearch from './faqs/FAQSearch';
import ServiceCenterSearch from './offices/ServiceCenterSearch';
import EfficiencyTips from './tips/EfficiencyTips';
import { useTranslation } from 'react-i18next';

const FaqsTabContent = () => {
  const [searchQuery, setSearchQuery] = useState("");
  return (
    <div className="space-y-6">
      <FAQSearch onSearch={setSearchQuery} />
      <FAQSection searchQuery={searchQuery} />
    </div>
  );
};

export const InfocenterLanding = () => {
  const { t } = useTranslation();
  
  const tabComponents = {
    offices: {
      label: t("Offices"),
      icon: <Building2 className="h-4 w-4" />,
      component: <ServiceCenterSearch />,
      shortLabel: t("Offices"),
    },
    faqs: {
      label: t("FAQ's"),
      icon: <HelpCircle className="h-4 w-4" />,
      component: <FaqsTabContent />,
      shortLabel: t("FAQ's"),
    },
    tips: {
      label: t("Tips"),
      icon: <Lightbulb className="h-4 w-4" />,
      component: <EfficiencyTips />,
      shortLabel: t("Tips"),
    },
  };

  return (
    <div className="h-screen flex flex-col bg-[#f8f9fa] font-sans overflow-hidden">
      <div className="shrink-0">
        <GuestPortalTopnav />
        
        {/* Banner */}
        <AnnouncementBanner />
      </div>
  
      {/* Container */}
      <div className="flex-1 overflow-y-auto w-full">
        <div className="w-full p-4">
          {/* Main Title */}
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-gray-900 ">{t("Utility Information Center")}</h1>
            <p className="text-gray-500">
              {t("Office timings, contact numbers, tariff rates, outage notices, and downloads.")}
            </p>
          </div>

          {/* Tabs */}
          <Tabs
            defaultValue="offices"
            tabComponents={tabComponents}
            urlMapping={{
              offices: "offices",
              faqs: "faqs",
              tips: "tips",
            }}
            tabsListClassName="grid grid-cols-3 w-full mb-6"
            tabsListFullWidth={true}
            idPrefix="info-center"
          />
        </div>
      </div>
    </div>
  );
};